import React from 'react'
import styles from './styles.module.css';

const Header = () => {
  return (
    <div style={{margin: '2em 0'}}>
       <div className={styles.header}>
        SPICE ROUTE CATTERS
    </div>

    <div className={styles.sub_heading}>
        Catering & Events
    </div>
      
    </div>
  )
}

export default Header 